import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { coastalFusionPoints } from "../../mock";

export default function AboutSection() {
  return (
    <section className="relative bg-cream py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-32 h-32 border-2 border-spice-gold hidden lg:block" />
            <div className="relative overflow-hidden">
              <img
                src="/image/siteimages/about/photo-1517248135467-4c7edcad34c4.jpg"
                alt="Sea Spice Kitchen dining room"
                className="w-full h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-sea-deep text-white px-8 py-6 hidden lg:block">
              <div className="font-display text-4xl text-spice-gold">2026</div>
              <div className="text-xs tracking-[0.25em] uppercase mt-1">Est. Frankston</div>
            </div>
          </div>

          {/* Copy */}
          <div>
            <span className="divider-ornament">Our Story</span>
            <h2 className="font-display text-sea-deep text-4xl md:text-5xl lg:text-6xl font-medium leading-[1.1] mt-5 mb-6">
              Where coastal freshness meets <em className="text-spice-gold font-light">global flavour</em>
            </h2>
            <p className="text-sea-mid/85 text-base md:text-lg leading-relaxed mb-5">
              At Sea Spice Kitchen, we bring together the best of the world's coastal cuisines to
              create a unique dining experience we proudly call <strong className="text-sea-deep">Coastal Fusion</strong>.
            </p>
            <p className="text-sea-mid/85 text-base leading-relaxed mb-8">
              Nestled in the heart of Frankston, our menu celebrates the bounty of the ocean,
              combining premium Australian seafood with vibrant flavours from India, the Mediterranean and beyond — every
              dish crafted with fresh local ingredients, aromatic herbs and carefully selected spices.
            </p>

            {/* Points */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5 mb-10">
              {coastalFusionPoints.slice(0, 4).map((p) => (
                <div key={p.title} className="flex gap-3">
                  <div className="w-1.5 h-1.5 rounded-full bg-spice-gold mt-2 flex-shrink-0" />
                  <div>
                    <div className="font-display text-sea-deep text-lg">{p.title}</div>
                    <div className="text-sea-mid/75 text-sm leading-relaxed">{p.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/about">
              <Button className="bg-sea-deep hover:bg-[hsl(184_60%_10%)] text-white rounded-none px-8 h-12 tracking-wide">
                Discover More
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
